import { call, put, takeEvery } from "redux-saga/effects";
import { types } from "../action-types";
import {
  getCompanyDetailsDropdownApi,
  postCompanyDetailsApi,
} from "../../API/API";

function* fetchCompanyDetailsDropdown(action) {
  try {
    // const { _id } = action.payload;
    const response = yield call(() => getCompanyDetailsDropdownApi());
    yield put({
      type: types.GET_COMPANY_DETAILS_SUCCESS,
      payload: response.data,
    });
  } catch (error) {
    yield put({ type: types.GET_COMPANY_DETAILS_FAILURE, error });
  }
}

function* postCompanyDetails(action) {
  try {
    // const {CompanyName,IndustryName,YearFounded,CompanyType,CompanySize} =action.payload
    const response = yield call(() => postCompanyDetailsApi(action.payload));
    yield put({
      type: types.POST_COMPANY_DETAILS_SUCCESS,
      payload: response.data,
    });
    localStorage.setItem("profession",response.data.Professions.ProfessionCode);
    localStorage.setItem('companyDetails',JSON.stringify(response.data.profile));
  } catch (error) {
    yield put({ type: types.POST_COMPANY_DETAILS_FAILURE, error });
  }
}

export function* watchCompanyDetailsDropdown() {
  yield takeEvery(
    types.GET_COMPANY_DETAILS_REQUESTED,
    fetchCompanyDetailsDropdown
  );
}

export function* watchCompanyDetailsSaga() {
  yield takeEvery(types.POST_COMPANY_DETAILS_REQUESTED, postCompanyDetails);
}
